import { jsx as _jsx } from "react/jsx-runtime";
import { SovosAboutThisDialog } from 'mosaic-react';
import useSovosPlatformContext from '../sovos-platform-context';
const SovosAboutThisProductDialog = ({ description, learnMoreUrl, onClose, open, privacyPolicyUrl, termsAndConditionsUrl, version, }) => {
    const { activeProduct } = useSovosPlatformContext();
    if (!activeProduct) {
        return null;
    }
    return (_jsx(SovosAboutThisDialog, { description: description, learnMoreUrl: learnMoreUrl, onClose: onClose, open: open, privacyPolicyUrl: privacyPolicyUrl, productIconUrl: activeProduct.iconEncodedSvg, productName: activeProduct.name, termsAndConditionsUrl: termsAndConditionsUrl, version: version }));
};
export default SovosAboutThisProductDialog;
